/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Shipping_N_Delivery__Question_2Inputs */

const en_help_center__shipping_n_delivery__question_2 = /** @type {(inputs: Help_Center__Shipping_N_Delivery__Question_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long does delivery take?`)
};

/**
* | output |
* | --- |
* | "How long does delivery take?" |
*
* @param {Help_Center__Shipping_N_Delivery__Question_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__shipping_n_delivery__question_2 = /** @type {((inputs?: Help_Center__Shipping_N_Delivery__Question_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Shipping_N_Delivery__Question_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__shipping_n_delivery__question_2(inputs)
});